export const naming = {
  manage: {
    en: 'Manage $$',
    km: 'គ្រប់គ្រង$$'
  },
  list: {
    en: 'List $$',
    km: 'មើលបញ្ជី$$'
  },
  show: {
    en: 'View $$ Detail',
    km: 'បង្ហាញព័ត៌មានលម្អិត$$'
  },
  store: {
    en: 'Store $$',
    km: 'រក្សាទិន្នន័យ$$'
  },
  create: {
    en: 'Create $$',
    km: 'រក្សាទិន្នន័យ$$'
  },
  edit: {
    en: 'Edit $$',
    km: 'កែសម្រួលទិន្នន័យ$$'
  },
  delete: {
    en: 'Delete $$',
    km: 'លុបទិន្នន័យ$$'
  },
  changePassword: {
    en: 'Change $$\'s Password',
    km: 'កែពាក្យសម្ងាត់របស់$$'
  },
  search: {
    en: 'Search $$',
    km: 'ស្វែងរក$$'
  },
  showHistory: {
    en: 'Show History $$',
    km: 'មើលព័ត៌មានប្រវិត្ត$$'
  }
}
